import { render } from "./loginForm.vue?vue&type=template&id=6cd2326c&scoped=true"
import script from "./loginForm.vue?vue&type=script&lang=js"
export * from "./loginForm.vue?vue&type=script&lang=js"

import "./loginForm.vue?vue&type=style&index=0&id=6cd2326c&scoped=true&lang=css"

import exportComponent from "/home/forge/clients-dev.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd2326c"]])

export default __exports__